export const getPlaylistUrl = (
  serverUrl: string,
  moduleId: string,
  viewerToken?: string,
  includesPlaylist: boolean = true,
) =>
  `${serverUrl}/streams/${moduleId}${includesPlaylist ? '/playlist.m3u8' : ''}${
    viewerToken ? `?viewer_token=${viewerToken}` : ''
  }`;

export async function testVideoSource(url: string) {
  try {
    const response = await fetch(url);
    if (response.ok) {
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error fetching video source:', error);
    return false;
  }
}
